<template>
  <div class="content">
    <el-row class="bgW">
      <el-col :span="22">
        <!--检索条件-->
        <el-form
          class="search"
          :inline="true"
          label-suffix="："
          size="mini"
          :model="search"
        >
          <el-form-item label="领取时间">
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="search.create_time_start"
              type="date"
              placeholder="开始日期"
              size="mini"
              clearable
              class="w130"
            />
            <span class="mx-4">至</span>
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="search.create_time_end"
              type="date"
              placeholder="结束日期"
              size="mini"
              clearable
              class="w130"
            />
          </el-form-item>
          <el-form-item label="使用时间">
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="search.use_time_start"
              type="date"
              placeholder="开始日期"
              size="mini"
              clearable
              class="w130"
            />
            <span class="mx-4">至</span>
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="search.use_time_end"
              type="date"
              placeholder="结束日期"
              size="mini"
              clearable
              class="w130"
            />
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input
              class="w130"
              v-model="search.customer_name"
              clearable
              placeholder="请输入客户名称"
            />
          </el-form-item>
          <el-form-item label="门店名称">
            <el-input
              class="w130"
              v-model="search.shop_name"
              clearable
              placeholder="请输入门店名称"
            />
          </el-form-item>
          <el-form-item label="市场">
            <el-select
              class="w130"
              v-model="search.market_id"
              clearable
              filterable
              placeholder="请选择市场"
            >
              <el-option
                v-for="item in options.market_id"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="会员等级">
            <el-select
              class="w130"
              v-model="search.member_level"
              clearable
              placeholder="请选择会员等级"
            >
              <el-option
                v-for="item in options.member_level"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <!-- 新增：优惠券名称 -->
          <el-form-item label="优惠券名称">
            <el-input
              class="w130"
              v-model="search.coupon_name"
              clearable
              placeholder="请输入优惠券名称"
            />
          </el-form-item>

          <!-- 新增：优惠券类型 -->
          <el-form-item label="优惠券类型">
            <el-select
              class="w130"
              v-model="search.coupon_type"
              clearable
              placeholder="请选择优惠券类型"
            >
              <el-option
                v-for="item in options.couponTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <!-- 新增：状态 -->
          <el-form-item label="状态">
            <el-select
              class="w130"
              v-model="search.status"
              clearable
              placeholder="请选择状态"
            >
              <el-option
                v-for="item in options.statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="2" style="text-align: right">
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="getList('search')"
        >搜索</el-button>
      </el-col>
    </el-row>
    <div class="accountCon">
      <el-button
        @click="exportData"
        type="primary"
        class="mb10"
        size="mini"
        :loading="loading"
      >导出数据</el-button>
      <!--列表-->
      <el-row>
        <el-col :span="24">
          <el-table
            :data="list"
            size="small"
            border
            :cell-style="$style.cellStyle"
            :header-cell-style="$style.rowClass"
          >
            <ElTableColumn label="ID" prop="id" width="80"/>
            <ElTableColumn label="客户名称" prop="customer_name" width="100" />
            <ElTableColumn label="会员等级" prop="member_level_text" />
            <ElTableColumn label="手机号" prop="telephone" width="100" />
            <ElTableColumn label="店铺名称" prop="shop_name"  />
            <ElTableColumn label="市场名称" prop="market_name" />
            <ElTableColumn label="优惠券名称" prop="coupon_name" />
            <ElTableColumn label="优惠券类型" prop="coupon_type"  />
            <ElTableColumn label="面值(元)" prop="denomination"  />
            <ElTableColumn label="领取时间" prop="receive_time"/>
            <ElTableColumn label="领取方式" prop="receive_method" width="80" /> 
            <ElTableColumn label="使用时间" prop="use_time"/>
            
            <ElTableColumn label="验证人" prop="verifier" width="80" />
            <!-- 可额外加一列状态展示 -->
            <ElTableColumn label="券状态" prop="status" width="80"/>
          </el-table>
          <pagination
            class="page tc mt10"
            :total="page.total"
            :page.sync="page.page"
            :limit.sync="page.limit"
            @pagination="getList"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import pagination from '@/components/Pagination';
import { getWriteOff,deleteCard } from '@/api/card';
import { readAdminMarketList } from '@/api/shop';

class Page {
  total = 0;
  page = 1;
  limit = 10;
}

// 扩展搜索类，新增所有条件
class Search {
  customer_name = '';
  shop_name = "";
  market_id = "";
  coupon_name = '';
  coupon_type = '';
  status = '';
  create_time_start = '';
  create_time_end = '';
  use_time_start = '';
  use_time_end = '';
  is_export = 0;
  member_level = '';
}

class Options {
  constructor () {
    this.market_id = []
    // 新增下拉数据源
    this.couponTypeList = [
      { label: '满减券', value: 1 },
      { label: '满赠券', value: 3 },
      { label: '兑换券', value: 4 }
    ]
    this.statusList = [
      { label: '未使用', value: '未使用' },
      { label: '已使用', value: '已使用' },
      { label: '已过期', value: '已过期' }
    ]
    this.member_level = [
      { label: '无', value: 0 },
      { label: '白玉兰', value: 1 },
      { label: '紫玉兰', value: 2 },
      { label: '金玉兰', value: 3 }
    ]
  }
}

export default {
  name: 'CardList',
  components: {
    pagination
  },
  data () {
    return {
      loading: false,
      search: new Search(), // 检索条件
      options: new Options(), // 选项
      page: new Page(), // 分页
      list: [], // 数据展示
      idList: ''
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  mounted () {
    this.getList()
    this.getOptions();
  },
  methods: {
    // 获取选项
    getOptions() {
      readAdminMarketList().then(res => {
        this.options.market_id = res.list;
      });
    },
    exportData(){
      this.loading = true;
      this.search.is_export = 1;
      getWriteOff({...this.search}).then(res => {
        window.open(res.data.url);
      }).catch(() => {
      }).finally(() => {
        this.loading = false;
      })
    },
    getList (option) {
      this.search.is_export = 0;

      if (option === 'search') this.page = new Page();
      getWriteOff({...this.search,...this.page}).then(res => {
        this.list = res.data.list;
        this.page.total = res.data.dataCount;
      })
    },

    // 提示
    hint(type, text) {
      this.$confirm(`${text}，是否确定？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
            this.delCard(type);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 改变表格选中状态
    handleSelectionChange (val) {
      this.idList = val.map((i) => {
        return i.id
      })
    },
    // 删除
    delCard(id){
      deleteCard({id:id}).then(res => {
        console.log(res)
        this.$message({
            type: "success",
            message: res.msg
          });
        this.getList()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.bgW {
  background: #fff;
  border-radius: 3px;
  margin-bottom: 20px;
}
.el-form-item {
  margin: 5px 40px 3px 0;
}
.accountCon {
  background: #fff;
  padding: 10px 0px 80px;
}
.mx-4 {
  margin: 0 4px;
}
</style>